// import Events from 'components/pages/user/profile/Events';
import React from 'react';
import { Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import events from 'data/events/events';
import PropTypes from 'prop-types';
import moment from 'moment';

const TemplateDetailAside = ({ template }) => {
  return (
    <div className="sticky-sidebar">
      <Card className="mb-3 fs-10">
        <Card.Body>
          <h6>Date And Time</h6>
          <p className="mb-1">
            {moment(template?.startTime).format('ddd, MMM DD,YYYY, hh:mm A')} –{' '}
            <br />
            {moment(template?.endTime).format('ddd, MMM DD,YYYY, hh:mm A')}
          </p>
          {/* <Link to="#!">Add to Calendar</Link> */}
          <h6 className="mt-4">Duration</h6>
          <p className="fs-10 mb-0">{template?.jobDuration}</p>

          <h6 className="mt-4">Location</h6>
          {template?.unit && (
            <p className="fs-10 mb-0">
              {template?.unit} - {template?.floor}
            </p>
          )}
          <div className="mb-1">{template?.fullAddress}</div>
          <a
            href={`https://maps.google.com/?q=${template?.fullAddress}`}
            target="_blank"
            rel="noreferrer"
            className="text-primary"
          >
            View Map
          </a>
        </Card.Body>
      </Card>
      {/* <Events cardTitle="Events you may like" events={events.slice(2, 5)} /> */}
    </div>
  );
};

TemplateDetailAside.propTypes = {
  template: PropTypes.any
};

export default TemplateDetailAside;
